import {
  DEFAULT_TRANSITION,
  MotionNumberContext,
  MotionNumber_default
} from "./chunk-DYEYXMEG.mjs";

// src/index.tsx
import * as React from "react";
import { motion } from "framer-motion";
var MotionNumber = React.forwardRef(
  function MotionNumber2(props, ref) {
    return /* @__PURE__ */ React.createElement(MotionNumber_default, { ref, motion, ...props });
  }
);
var src_default = MotionNumber;
export {
  DEFAULT_TRANSITION,
  MotionNumberContext,
  src_default as default
};
